import { Component } from '@angular/core'

@Component({
   selector: 'app-history',
   standalone: true,
   imports: [],
   templateUrl: './history.component.html',
   styles: ''
})
export class HistoryComponent {

}
